
import {getReplenishment} from '../api/getReplenishment';
import {setGetReplenishmentAction} from '../action';

const setGetReplenishment = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '');
            const {data} = await getReplenishment(params);
           
            if (data.status === 'success') {
                dispatch(setGetReplenishmentAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetReplenishment
}